import { Tooltip } from 'antd';

/**
 * The array contains the path items that we want to skip for breadcrumbs
 */
export const pathItemsToSkip: readonly string[] = ['login', 'callback'];

/**
 * The max length of path in breadcrumbs
 */
export const pathItemMaxLength = 50;

/**
 * Generate react component based on path item and current user permission
 */
export const PathItemComponent = ({
  pathItem,
  permission,
}: {
  readonly permission: boolean;
  readonly pathItem: string;
}): JSX.Element => (
  <>
    {pathItem === 'teams' ? (
      'all teams'
    ) : pathItem === 'manage' && permission ? (
      'configure team'
    ) : pathItem === 'manage' && !permission ? (
      'view team'
    ) : pathItem.length <= pathItemMaxLength ? (
      pathItem
    ) : (
      <Tooltip title={pathItem}>
        {`${pathItem.substring(0, pathItemMaxLength)}...`}
      </Tooltip>
    )}
  </>
);
